var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYoutubeBlack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 22,
    viewBox: "0 0 32 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.3943 3.77823C30.2224 3.14449 29.8876 2.56677 29.4233 2.10246C28.959 1.63815 28.3813 1.30343 27.7476 1.13154C25.3983 0.488282 16.0003 0.488281 16.0003 0.488281C16.0003 0.488281 6.60225 0.488281 4.25245 1.1068C3.61923 1.28756 3.04317 1.62819 2.57965 2.09594C2.11614 2.56369 1.78076 3.14282 1.60576 3.77766C0.987244 6.12746 0.987244 10.9997 0.987244 10.9997C0.987244 10.9997 0.987244 15.8966 1.60576 18.2211C1.77738 18.855 2.11202 19.4328 2.57637 19.8972C3.04072 20.3615 3.61859 20.6962 4.25245 20.8678C6.62699 21.511 16.0003 21.511 16.0003 21.511C16.0003 21.511 25.3983 21.511 27.7476 20.8925C28.3814 20.7207 28.9591 20.3861 29.4235 19.9217C29.8878 19.4574 30.2225 18.8796 30.3943 18.2458C31.0099 15.8972 31.0099 11.025 31.0099 11.025C31.0099 11.025 31.0369 6.12803 30.3943 3.77823Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.823 11.0007L13.0078 6.49902V15.5018L20.823 11.0007Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeBlack);
export default __webpack_public_path__ + "static/media/youtubeBlack.43485bc0b31db5361f8a997046bda7c7.svg";
export { ForwardRef as ReactComponent };